class MobileMenu extends HTMLElement {
  constructor() {
    super();

    this.summary = this.querySelector("summary");
    this.details = this.querySelector("details");
    this.searchOpenButton =
      this.closest("header").querySelector("[data-search-open]");
    this.searchInput = this.querySelector("[data-mobile-input]");

    this.summary.addEventListener("click", (e) => {
      e.preventDefault();
      this._toggle();
    });

    this.addEventListener("mobile-submenu:close", () => {
      window.trapFocus(this.details);
    });

    this.closeEsc = (e) => {
      if (
        e.key === "Escape" &&
        this.classList.contains("open") &&
        !this.querySelector(".mobile-menu__main-mega-menu.open")
      ) {
        this._close();
      }
    };

    document.addEventListener("keydown", this.closeEsc);

    this.toggleDrawer = () => {
      if (!this._isMobile && this.details.open) {
        this._forceClose();
      }
    };

    this.searchOpenButton.addEventListener("click", (e) => {
      e.preventDefault();
      if (this.details.open) return;
      this._open();
    });

    document.addEventListener("mobile-search:open", (e) => {
      e.preventDefault();
      if (this.details.open) return;
      this._open();
    });

    window.addEventListener("resize", this.toggleDrawer);

    // In some versions of iOS the click event is not triggering until
    // the second tap. Other efforts to resolve this (removing hover states, etc)
    // have not worked so we listen for touchstart, which reliably fires on tap.
    this.addEventListener("touchstart", (e) => {
      const el = e.target.closest("a, button, summary");
      console.log(`el`, el);

      if (el) {
        e.stopPropagation();
        e.preventDefault();

        el.click();
      }
    });
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", this.closeEsc);
    window.removeEventListener("resize", this.toggleDrawer);
  }

  _toggle() {
    this.details.open ? this._close() : this._open();
  }

  _forceClose() {
    document.body.classList.remove("mobile-menu-open");
    this.classList.remove("open");
    this.details.open = false;
    window.closeDimmer(this);
    window.removeTrapFocus(this.summary);
    window.unlockScroll(this);
    this.removeEventListener("transitionend", this.onEnd);
  }

  _open() {
    this.details.open = true;
    window.requestAnimationFrame(() => {
      document.body.classList.add("mobile-menu-open");
      this.classList.add("open");
      this.dispatchEvent(new CustomEvent("menu:open", { bubbles: true }));
      window.lockScroll(this);
      window.openDimmer(this);
      this.style.setProperty(
        "--mobile-menu-top",
        `${this.closest(".header").getBoundingClientRect().bottom}px`,
      );
    });

    window.trapFocus(this.details);
  }

  _close() {
    document.body.classList.remove("mobile-menu-open");
    this.classList.remove("open");
    this.dispatchEvent(new CustomEvent("menu:close", { bubbles: true }));

    const onEnd = () => {
      this.removeEventListener("transitionend", onEnd);

      if (this.classList.contains("open")) return;
      this.details.open = false;
      window.removeTrapFocus(this.summary);
      window.unlockScroll(this);
      window.closeDimmer(this);
      this.dispatchEvent(
        new CustomEvent("mobile-menu:closed", { bubbles: true }),
      );
    };

    this.addEventListener("transitionend", onEnd);
  }

  get _isMobile() {
    return window.matchMedia("(max-width: 959px)").matches;
  }
}

if (!customElements.get("mobile-menu")) {
  customElements.define("mobile-menu", MobileMenu);
}
